
<template>
  <adminAccountManager :isInPage="true" :queryByCmp="true" :company="companyId"></adminAccountManager>
</template>
<script>
import adminAccountManager from '../../../comComponent/adminAccountManager'
export default {
  data () {
    return {
      companyId: ''
    }
  },
  props: {
    currentRow: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    'currentRow.id': {
      handler: function (val, oVal) {
        if (val) {
          this.companyId = val
        } else {
          this.companyId = ''
        }
      },
      deep: true
    }
  },
  mounted () {
    try {
      if (this.currentRow) {
        this.companyId = this.currentRow.id
      }
    } catch (err) {
      console.log(err)
    }
  },
  components: {
    adminAccountManager
  },
  methods: {
  }
}
</script>
<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/companyInfo/detailPage/adminAccount.vue